import React, { useState, useMemo, useCallback, useEffect } from 'react';
import { Grid } from '@mui/material';
import ComboBox from '../components/multiselectSearch';
import { isEqual } from 'lodash';

const LabelSection = ({
  cardId,
  data,
  checkBoardOwnerOrAdmin,
  currentUserId,
}) => {

    const [label, setLabel] = useState([]);
    const [showLabel, setShowLabel] = useState(false);

    useEffect(() => {
      setLabel(
        data?.labels?.map((item) => ({
          label: item.label,
          label_id: item.label_id,
        })) || []
      );
    }, [data?.labels]);

  // Memoize permission check
  const hasEditPermission = useMemo(
    () => checkBoardOwnerOrAdmin || data?.reporter === currentUserId(),
    [checkBoardOwnerOrAdmin, data?.reporter, currentUserId]
  );

  // Memoize handle show label
  const handleShowLabel = useCallback(() => {
    if (hasEditPermission) {
      setShowLabel(true);
    }
  }, [hasEditPermission]);

  if (data?.is_todo) return null;
  return (
    <div className="box">
      <Grid item className="allocated-hours">
        <p>Label</p>
        <div className="taskdetail-sidebar-right-col">
          {showLabel ? (
            <ComboBox
              labels={label}
              boardId={data?.board_id}
              cardId={cardId}
              setShowLabel={setShowLabel}
              hasEditPermission={hasEditPermission}
            />
          ) : (
            <div className="due-date" onClick={handleShowLabel}>
              <div className="due-date-input">
                {data?.labels.length !== 0 ? (
                  data?.labels.map((item) => item.label).join(", ")
                ) : (
                  <p className="due-date-input-none">None</p>
                )}
              </div>
            </div>
          )}
        </div>
      </Grid>
    </div>
  );
};

const areEqual = (prevProps, nextProps) => {
  return prevProps?.data?.assigned_to_user_id === nextProps?.data?.assigned_to_user_id
  && prevProps?.data?.reporter === nextProps?.data?.reporter
  && prevProps?.data?.is_todo === nextProps?.data?.is_todo
  && prevProps?.data?.board_id === nextProps?.data?.board_id
  && prevProps?.cardId === nextProps?.cardId
  && prevProps?.checkBoardOwnerOrAdmin === nextProps?.checkBoardOwnerOrAdmin
  && prevProps?.currentUserId === nextProps?.currentUserId
  && isEqual(prevProps?.data?.labels, nextProps?.data?.labels)
}

export default React.memo(LabelSection, areEqual);
